import {
    CLEAR_EVENT_RESULT,
    EVENTS_CHANGED,
    EVENTS_FETCHING_CHANGED,
    EVENTS_FILTER_CHANGED,
    EVENTS_FILTERS_CHANGED,
    EVENTS_FILTERS_FETCHING_CHANGED,
    EVENTS_PAGE_OFFSET_CHANGED,
    EVENTS_PAGINATED,
    EVENTS_PAGINATING_CHANGED,
    POPULAR_EVENTS_CHANGED,
    GET_EVENTS_BY_NAME_SUCCESS,
    OUTRIGHTS_CHANGED,
    OUTRIGHTS_PAGINATED,
    SET_SPORT_REF_ID,
    SET_SPORTS_COMPETITION_TYPE,
    SET_SPORTS_ESPORTS_TYPE,
    SET_SPORTS_EVENT_TYPE,
} from '../actions/types';
import { EVENT_FILTER_OPTIONS } from '../../constants/event-filters';
import { EVENT_TYPES, EVENTS_PAGE_LIMIT } from '../../constants/defaultValues';

const initialState = {
    sportRefId: '',
    filters: {},
    isFiltersFetching: true,
    shouldUpdateEvents: false,
    pageOffset: 0,
    isFetching: false,
    isPaginating: false,
    hasNextPage: false,
    events: [],
    popularEvents: [],
    total: 0,
    sortType: EVENT_FILTER_OPTIONS.orders.byLeague.id,
    eventsByName: [],
    isLive: null,
    isESports: null,
    eventType: EVENT_TYPES[0],
};

export default function (state = initialState, action) {
    const { payload } = action;

    switch (action.type) {
        case SET_SPORT_REF_ID: {
            return { ...state, sportRefId: payload };
        }
        case EVENTS_FILTERS_CHANGED: {
            return {
                ...state,
                filters: payload.filters,
                shouldUpdateEvents: payload.shouldUpdateEvents,
                isFiltersFetching: false,
            };
        }
        case EVENTS_FILTER_CHANGED: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [payload.key]: payload.value,
                },
                shouldUpdateEvents: true,
                isFiltersFetching: false,
            };
        }
        case EVENTS_FILTERS_FETCHING_CHANGED: {
            return {
                ...state,
                isFiltersFetching: payload,
            };
        }
        case EVENTS_FETCHING_CHANGED:
            return { ...state, isFetching: payload, events: [] };
        case EVENTS_PAGINATING_CHANGED:
            return { ...state, isPaginating: payload };
        case EVENTS_CHANGED:
            return {
                ...state,
                ...payload,
                shouldUpdateEvents: false,
            };
        case EVENTS_PAGINATED: {
            const { sortType, events } = payload;

            let newEvents;
            let hasNextPage = true;

            if (sortType === EVENT_FILTER_OPTIONS.orders.byLeague.id) {
                newEvents = state.events.map(season => {
                    const duplicateSeason = events.find(s => s.id === season.id);

                    if (duplicateSeason) {
                        const filteredEvents = duplicateSeason.events.filter(event => {
                            return !season.events.find(e => e.id === event.id);
                        });

                        return { ...season, events: season.events.concat(filteredEvents) };
                    }

                    return season;
                });

                const filteredSeasons = events.filter(season => {
                    return !state.events.find(s => s.id === season.id);
                });

                newEvents = newEvents.concat(filteredSeasons);
                hasNextPage = events.flatMap(s => s.events).length >= EVENTS_PAGE_LIMIT;
            } else if (
                sortType === EVENT_FILTER_OPTIONS.orders.byTime.id ||
                sortType === EVENT_FILTER_OPTIONS.orders.byMbn.id
            ) {
                newEvents = state.events.concat(events);
                hasNextPage = events.length >= EVENTS_PAGE_LIMIT;
            }

            return {
                ...state,
                ...payload,
                events: newEvents,
                hasNextPage,
                shouldUpdateEvents: false,
            };
        }
        case EVENTS_PAGE_OFFSET_CHANGED: {
            return {
                ...state,
                pageOffset: payload,
            };
        }
        case POPULAR_EVENTS_CHANGED:
            return { ...state, popularEvents: payload.popularEvents };
        case GET_EVENTS_BY_NAME_SUCCESS:
            return { ...state, eventsByName: action.payload };
        case CLEAR_EVENT_RESULT:
            return { ...state, eventsByName: [] };
        case SET_SPORTS_COMPETITION_TYPE:
            return { ...state, isLive: payload };
        case SET_SPORTS_ESPORTS_TYPE:
            return { ...state, isESports: payload };
        case SET_SPORTS_EVENT_TYPE:
            return { ...state, eventType: payload };

        case OUTRIGHTS_CHANGED:
            return {
                ...state,
                shouldUpdateEvents: false,
            };
        case OUTRIGHTS_PAGINATED: {
            return {
                ...state,
                shouldUpdateEvents: false,
            };
        }

        default:
            return state;
    }
}
